import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { LocalStorageService } from './localstorage.service';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { resolve } from 'dns';
import { rejects } from 'assert';

const TIME_OUT = 60000;

@Injectable()
export class IncidentPopDataService {
    mode;

    basicInfo; // 事故基础资讯
    locationInfo; //事故地点数据
    otherInfo; // 其它资讯
    notifier = []; // 通知对象
    involvedEmployee = []; // 事故相关人-公司
    involvedContractor = []; // 事故相关人-承包商

    submitData; // 提交事故主记录数据（可能用到）
    hasChangedInvolvedPeople; // 是否改变了受伤人员信息

    clearData = false; // 清除数据

    isReport = true;  // 是否是事故上报
    editPerson = false; // 新增
    addPerson = false; // 编辑
    isTransfer = false; // 转派
    currentData; // 选择的数据

    org;
    isInvestigation;
    editable;
    previousType; // 当前受伤人员的类型
    personIndex;
    taskId;
    taskStatus;
    actionData; // 整改措施数据
    updateAction = false; // 刷新整改措施list

    signPropleEdit = false; // 传会签核人员权限
    isCorrectiveTurn = false; // 是事故整改
  
    persons;
    correctiveOrg;
    isCorrective;
    diagnosticObj;
    currentSign;
    activeSegment = '1';
    public pageSize = 10;
    public initBasic = true;
    public pendding = 0;
    public todo = 0;
    public urlPrefix = this.localStorageService.getStore('API_DOMAIN') + this.localStorageService.getStore('API_DIR');
    public refresh = false;
    constructor(
        private http: HttpClient,
        public router: Router,
        public localStorageService: LocalStorageService) {
    }

    setData(para, data): any {
        this[para] = data;
    }

    getData(para): any {
        return this[para];
    }

    setMoreData(para, data): any  {
        para.forEach((element, index) => {
            this[element] = data[index];
        });
    }

    getMoreData(para): Promise<any> {
        const obj = {};
        para.forEach((element, index) => {
            obj[element] = this[element];
        });

        return new Promise((resolve, reject) => {
            obj ? resolve(obj) : reject(obj);
        });
    }

    // 清除数据
    clear() {
        const initialState = {
            mode: null,
            basicInfo: null,
            locationInfo: null,
            otherInfo: null,
            notifier: [],
            involvedEmployee: [],
            involvedContractor: [],
            submitData: null,
            hasChangedInvolvedPeople: null,
            clearData: false,
            isReport: true,
            editPerson: false,
            addPerson: false,
            isTransfer: false,
            currentData: null,
            org: null,
            isInvestigation: null,
            editable: null,
            previousType: null,
            personIndex: null,
            taskId: null,
            taskStatus: null,
            actionData: null,
            updateAction: false,
            signPropleEdit: false,
            isCorrectiveTurn: false,
            persons: null,
            correctiveOrg: null,
            isCorrective: null,
            diagnosticObj: null,
            currentSign: null,
            activeSegment: '1',
            pageSize: 10,
            initBasic: true,
            pendding: 0,
            todo: 0,
            urlPrefix: this.localStorageService.getStore('API_DOMAIN') + this.localStorageService.getStore('API_DIR'),
            refresh: false
        };
        Object.keys(initialState).forEach((key) => {
            this[key] = initialState[key];
        });
    }

    deleteData(para): any {
        delete this[para];
    }
}
